import maharajImg from '../../../assets/images/maharaj-ji.png'

const PANEL_STATS = [
  { value: '50K+', label: 'Seekers' },
  { value: '₹0', label: 'Joining Fee' },
  { value: '24h', label: 'Review Time' },
]

const BENEFITS = [
  { icon: '🪐', text: 'Get discovered by thousands of active seekers on Vedic Astral.' },
  { icon: '🛡️', text: 'KYC-verified network. Your documents stay fully encrypted.' },
  { icon: '💰', text: 'Transparent payouts direct to your bank account, every week.' },
]

export default function InfoPanel() {
  return (
    <div className="lg:sticky lg:top-28">
      <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/20 border border-goldPrimary/10">
        <img
          src={maharajImg}
          alt="Astro Raju Maharaj Ji reading a Vedic birth chart"
          className="w-full h-[420px] lg:h-[520px] object-cover object-top"
        />
        <div className="absolute inset-0 bg-linear-to-t from-astroDark via-astroDark/10 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <p className="text-[9px] uppercase font-bold tracking-[0.25em] text-goldPrimary/80 mb-1.5">
            Vedic Astrologer Network
          </p>
          <h3 className="text-white text-xl font-royal leading-snug">
            Guide seekers with authentic Vedic wisdom
          </h3>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-3 gap-3 text-center">
        {PANEL_STATS.map((stat) => (
          <div key={stat.label} className="bg-white rounded-2xl border border-goldPrimary/10 p-4">
            <p className="font-royal text-2xl text-astroDark">{stat.value}</p>
            <p className="text-[10px] uppercase tracking-widest text-stone-400 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 space-y-4 bg-white rounded-2xl border border-goldPrimary/10 p-6">
        {BENEFITS.map((benefit) => (
          <div key={benefit.icon} className="flex items-start gap-3">
            <span className="w-8 h-8 rounded-lg bg-goldPrimary/10 text-goldAccent flex items-center justify-center text-sm shrink-0">
              {benefit.icon}
            </span>
            <p className="text-[13px] text-stone-500 leading-relaxed">{benefit.text}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
